<template>
    <option :class="{ 'desabilitado': !tpChamado.ativo }" :value="tpChamado.id" class="texto">
        {{ tpChamado.descricao }}
    </option>

    <FiltroSubTipo v-for="tpChamado in state.listSub" :key="tpChamado.id" :value="tpChamado.id" :tpChamado="tpChamado" />
</template>

<script setup>
import FiltroSubTipo from './FiltroSubTipo.vue';
import api from '@/api/api';
import TipoChamado from '@/model/TipoChamado';
import { reactive, defineProps, onMounted } from 'vue';

const props = defineProps(['tpChamado']);

const state = reactive({
    listSub: []
});

onMounted(() => {
    api.tipoChamadoListarSub(props.tpChamado.id)
        .then(resp => {
            resp.forEach(r => {
                state.listSub.push(new TipoChamado(r.id, r.descricao, r.ativo, r.cor, r.som, r.fonte, r.borda, r.corIcone, r.urgencia, r.id_Principal));
            });
        });
});
</script>

<style scoped>
.desabilitado {
    display: none;
}

.texto {
    text-align: center;
}
</style>